/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_register_benefits_view_track_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Sledujte své objednávky a mnoho dalšího`
};

const da_account_register_benefits_view_track_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Følg dine ordrer og mere`
};

const de_account_register_benefits_view_track_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Bestellungen verfolgen und mehr`
};

const en_account_register_benefits_view_track_orders = /** @type {(inputs: {}) => string} */ () => {
	return `View and track orders and more`
};

const es_account_register_benefits_view_track_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Sigue tus pedidos y mucho más`
};

const fr_account_register_benefits_view_track_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Suivez vos commandes et bien plus`
};

const hu_account_register_benefits_view_track_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Nyomon követheted rendeléseid és még sok minden`
};

const it_account_register_benefits_view_track_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Traccia i tuoi ordini e altro`
};

const nl_account_register_benefits_view_track_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Bestellingen volgen en meer`
};

const pl_account_register_benefits_view_track_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Śledź swoje zamówienia i więcej`
};

const pt_account_register_benefits_view_track_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Acompanhe seus pedidos e muito mais`
};

const sv_account_register_benefits_view_track_orders = /** @type {(inputs: {}) => string} */ () => {
	return `Följ dina beställningar och mer`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_register_benefits_view_track_orders = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_register_benefits_view_track_orders(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_register_benefits_view_track_orders", locale)
	if (locale === "cs") return cs_account_register_benefits_view_track_orders(inputs)
	if (locale === "da") return da_account_register_benefits_view_track_orders(inputs)
	if (locale === "de") return de_account_register_benefits_view_track_orders(inputs)
	if (locale === "en") return en_account_register_benefits_view_track_orders(inputs)
	if (locale === "es") return es_account_register_benefits_view_track_orders(inputs)
	if (locale === "fr") return fr_account_register_benefits_view_track_orders(inputs)
	if (locale === "hu") return hu_account_register_benefits_view_track_orders(inputs)
	if (locale === "it") return it_account_register_benefits_view_track_orders(inputs)
	if (locale === "nl") return nl_account_register_benefits_view_track_orders(inputs)
	if (locale === "pl") return pl_account_register_benefits_view_track_orders(inputs)
	if (locale === "pt") return pt_account_register_benefits_view_track_orders(inputs)
	return sv_account_register_benefits_view_track_orders(inputs)
};
export { account_register_benefits_view_track_orders as "account.register_benefits.view_track_orders" }